import styled, { css } from 'styled-components'

const StyledTaskPageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
  background-color: white;
  margin: -1rem -1.5rem;
  margin-bottom: 1rem;
  padding: 0 0.5rem;
  height: 4rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  ${props =>
    props.sticky &&
    css`
      position: sticky;
      top: 0;
      z-index: 999;
      height: 2rem;
    `};
`

export default StyledTaskPageHeader
